export enum Title {
  Home = 'Home',
  Advantages = 'Advantages',
  Subscription = 'Subscription'
}
